import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Box,
  TextField,
} from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import { inject, observer } from 'mobx-react'
import { Tag, Tooltip, Upload } from 'antd'
// import RichEditor from '../../components/RichEditor/RichEditor'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers'
import queryString from 'query-string'
import * as Yup from 'yup'
import {
  AiFillBank,
  AiOutlineDelete,
  AiOutlineFolder,
  AiOutlineTeam,
  AiOutlineUpload,
  AiOutlineUser,
} from 'react-icons/ai'
import { ASSIGNEE_TYPE } from '../../utils/constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'
import { AvatarHasName } from '../../components/common/Avatar'
import '../../components/RichEditor/RichEditor.scss'
import RichEditor from '../../components/RichEditor/RichEditor'
import { MyUploadAdapter } from './../../components/RichEditor/MyUploadAdapter'
import { useNavigate } from 'react-router-dom'
import { WORK_STATUS } from '../../constants'
import PopupRenameFile from '../../components/PopupRenameFile/PopupRenameFile'
import utils from '../../utils'
import { SelectList } from '../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled'
import moment from 'moment'
const toolbar = [
  'insertTable',
  'Alignment',
  'Autoformat',
  'AutoLink',
  'BlockQuote',
  'Bold',
  'Essentials',
  'FontBackgroundColor',
  'FontColor',
  'FontFamily',
  'FontSize',
  'Heading',
  'Image',
  'ImageInsert',
  'ImageResize',
  'ImageStyle',
  'ImageToolbar',
  'ImageUpload',
  'Indent',
  'IndentBlock',
  'Italic',
  'Link',
  'List',
  'ListStyle',
  'MediaEmbed',
  'MediaEmbedToolbar',
  'Mention',
  'Paragraph',
  'PasteFromOffice',
  'Strikethrough',
  'Table',
  'TableCellProperties',
  'TableProperties',
  'TableToolbar',
  'TextTransformation',
  'TodoList',
  'Underline',
  'WordCount',
]
const UpdateModal = props => {
  let {
    loadingAnimationStore,
    open,
    handleClose,
    workStore,
    selectPeopleStore,
    fileStore,
    createMessage,
  } = props
  const EDITOR_REF = useRef()
  const [editorState, setEditorState] = useState(null)
  const [data, setData] = useState('')

  const { workList, workDetail } = workStore
  useEffect(() => {
    if (editorState) {
      const editor = editorState
      editor.plugins.get('FileRepository').createUploadAdapter = function (
        loader
      ) {
        return new MyUploadAdapter(loader)
      }

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        )

      editor.editing.view.change(writer => {
        writer.setStyle(
          'height',
          '200px',
          editor.editing.view.document.getRoot()
        )
      })
    }
  }, [editorState])
  const [fileFromDocumentList, setFileFromDocumentList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [fileList, setFileList] = useState([])
  const [fileExt, setFileExt] = useState(undefined)
  const [fileTargetRename, setFileTargetRename] = useState(null)
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false)
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false)
  const userList = workDetail?.assignees
    ? workDetail?.assignees?.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      )
    : []
  const departmentList = workDetail?.assignees
    ? workDetail?.assignees?.filter(
        el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT
      )
    : []
  const groupList = workDetail?.assignees
    ? workDetail?.assignees?.filter(
        el => el.assignee_type === ASSIGNEE_TYPE.GROUP
      )
    : []
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
    clearSelectPeopleStore,
    clearSelected,
  } = selectPeopleStore
  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const assigneesList = workDetail?.assignees?.filter(
    item => item.permission !== 'CREATE'
  )
  const new_items_assign = []
  const remove_items_assign = []
  const listAssignOrigin = [...userList, ...departmentList, ...groupList].map(
    el => ({
      assignee_code: el.assignee_code,
      assignee_type: el.assignee_type,
      permission: el.permission,
    })
  )
  const listAssignAfter = [...followerList, ...handlerList].map(el => ({
    assignee_code: el.id,
    assignee_type: el.assignee_type,
    permission: el.permission,
  }))
  // if (handlerList.length === 0) {
  //   return isElectronicWork
  //     ? message.info('Bạn chưa chọn lãnh đạo ký duyệt!')
  //     : message.info('Bạn chưa chọn người xử lý!')
  // }
  listAssignAfter.forEach(assignAfter => {
    if (
      !listAssignOrigin.some(
        assignOrigin =>
          assignOrigin.assignee_code + assignOrigin.permission ===
          assignAfter.assignee_code + assignAfter.permission
      )
    ) {
      new_items_assign.push({
        assignee_code: assignAfter.assignee_code,
        assignee_type: assignAfter.assignee_type,
        permission: assignAfter.permission,
      })
    }
  })
  listAssignOrigin.forEach(assignOrigin => {
    if (
      !listAssignAfter.some(
        assignAfter =>
          assignAfter.assignee_code + assignAfter.permission ===
          assignOrigin.assignee_code + assignOrigin.permission
      )
    ) {
      remove_items_assign.push({
        assignee_code: assignOrigin.assignee_code,
        assignee_type: assignOrigin.assignee_type,
        permission: assignOrigin.permission,
      })
    }
  })
  useEffect(() => {
    if (!true) return

    if (
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userList)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentList)
      )
    }

    if (
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupList)
      )
    }
  }, [originDepartmentWithUserList])
  const [fileUploadedList, setFileListUpdate] = useState([])
  const fileUploaded = fileUploadedList?.map(item => item.file_id)
  const attachmentsList = workDetail?.attachments?.map(item => item.file_id)
  const updateAssignees = useCallback(() => {
    const res = [...followerList, ...handlerList].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    // let result = new_items.concat(assigneesList)
    formik.setFieldValue('assignees', {
      new_items: new_items_assign,
      remove_items: remove_items_assign,
    })
    formik.setFieldValue('current_assignees', listAssignAfter)
  }, [followerList, handlerList])

  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const res = response
      .map(response => response.data.file_id)
      .concat(fileFromDocumentList.map(file => file.file_id))
    let result = res.concat(fileUploaded)
    formik.setFieldValue('attachments', result)
  }, [fileList])
  useEffect(() => {
    formik.setFieldValue('content', data)
  }, [data])
  useEffect(() => {
    updateAttachments()
    updateAssignees()
  }, [updateAssignees, updateAttachments])

  const navigate = useNavigate()
  const [limit, setLimit] = useState(1)

  useEffect(() => {
    if (new_items_assign?.length > 0) {
      setLimit(formik.values.current_assignees?.length)
    } else if (remove_items_assign.length > 0) {
      setLimit(
        formik.values.current_assignees?.length - remove_items_assign?.length
      )
    }
  }, [handlerList, followerList])
  // console.log("formik.values.assignees.new_items", limit);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: workDetail?.title,
      content: workDetail?.content,
      start_date: workDetail?.start_date,
      due_date: workDetail?.due_date,
      attachments: attachmentsList,
      assignees: {
        new_items: new_items_assign,
        remove_items: remove_items_assign,
      },
      current_assignees: assigneesList,
      code: workDetail?.code,
      work_type: workDetail?.work_type,
    },
    validationSchema: Yup.object().shape({
      title: Yup.string()
        .required('Vui lòng nhập tiêu đề !')
        .matches(/^(?=.*\S).+$/, 'Vui lòng nhập tiêu đề !'),
      start_date: Yup.string().required('Vui lòng chọn ngày bắt đầu !'),
      assignees: Yup.object().shape({
        new_items: Yup.array().min(1, 'Vui lòng chọn người xử lý !'),
        remove_items: Yup.array().max(
          limit,
          'Bạn không thể xóa hết người xử lý !'
        ),
      }),
    }),
    onSubmit: async values => {
      try {
        loadingAnimationStore.showSpinner(true)
        await workStore.updateWork(workDetail?.code, values)
        const responseDetail = await workStore.getWorkDetail(workDetail?.code)
        const parentId = utils.getParameterByName('parent_id')
        if (parentId) {
          await workStore.getListSubWork(responseDetail.data.code)
        } else {
          const newWorkList = [...workList]
          const indexParentTarget = workList.findIndex(
            item => item.code === workDetail?.code
          )
          newWorkList[indexParentTarget] = {
            ...responseDetail.data,
            has_subwork: responseDetail.data?.subwork?.length > 0,
          }
          loadingAnimationStore.showSpinner(false)
          workStore.setWorkList(newWorkList)
        }
        createMessage('Cập nhật công việc thành công!', true, 'success')
      } catch (err) {
        // console.log(err)
      } finally {
        close()
        setLimit(formik.values.current_assignees?.length)
      }
    },
  })
  const close = () => {
    formik.resetForm()
    selectPeopleStore.clearSelected()
    setData('')
    setFileListUpdate(workDetail.attachments)
    setFileList([])
    setHandlerList([])
    setFollowerList([])
    handleClose()
    setAdvanceFilter({
      ...advanceFilter,
      month: '',
    })
    setAdvanceFilterEnd({
      ...advanceFilter,
      month: '',
    })
    return navigate(`/work/view/${workDetail?.code}`)
  }
  const handleChangeStart = value => {
    const endDate = moment(formik.values.due_date?.$d).format('DD/MM/YYYY')
    const startDate = moment(value.$d).format('DD/MM/YYYY')

    if (
      moment(endDate, 'DD/MM/YYYY').isSameOrAfter(
        moment(startDate, 'DD/MM/YYYY')
      )
    ) {
      setAdvanceFilter({
        ...advanceFilter,
        month: value,
      })
      formik.setFieldValue('start_date', value)
    } else {
      createMessage(
        'ngày bắt đầu không thể muộn hơn ngày kết thúc , xin vui lòng chọn lại !!!',
        true,
        'error'
      )
    }
  }
  const handleChangeEnd = value => {
    const startDate = moment(formik.values.start_date?.$d).format('DD/MM/YYYY')
    const endDate = moment(value.$d).format('DD/MM/YYYY')

    if (
      moment(endDate, 'DD/MM/YYYY').isSameOrAfter(
        moment(startDate, 'DD/MM/YYYY')
      )
    ) {
      setAdvanceFilterEnd({
        ...advanceFilter,
        month: value,
      })
      formik.setFieldValue('due_date', value)
    } else {
      createMessage(
        'ngày kết thúc không thể sớm hơn ngày bắt đầu, xin vui lòng chọn lại !!!',
        true,
        'error'
      )
    }
  }

  const [advanceFilter, setAdvanceFilter] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const [advanceFilterEnd, setAdvanceFilterEnd] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const handleFileChange = useCallback(async info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])
  // const handleRemoveFileFromDocumentList = file_id => {
  //   const newFileList = fileFromDocumentList.filter(
  //     file => file.file_id !== file_id
  //   )
  //   setFileFromDocumentList(newFileList)
  // }
  useEffect(() => {
    setFileListUpdate(workDetail?.attachments)
  }, [workDetail])
  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const handleRemoveFileUpdate = useCallback(
    file_id => {
      const newFileList = fileUploadedList.filter(
        file => file.file_id !== file_id
      )
      setFileListUpdate(newFileList)
    },
    [fileUploadedList]
  )
  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.file_name),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.file_name))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }
  const handleOpenPopupRenameNewFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.name),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.name))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }
  const submitRenameFile = async value => {
    const index = fileTargetRename?.index

    // Đổi tên file update
    if (isRenameFileUpdate) {
      await fileStore.handleRenameFile(
        fileTargetRename.file_id,
        value.rename + fileExt
      )
      const fileUpdateAfterRename = [...fileUploadedList]
      fileUpdateAfterRename[index].file_name = value.rename + fileExt
      setFileListUpdate(fileUpdateAfterRename)
      setIsModalVisibleRenameFile(false)
      createMessage('Đổi tên file thành công', true, 'success')
      return
    }
    // đổi tên file nhận từ thiết bị (file chưa ký)
    else if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      )
      setFileList(newFileList)
      setIsModalVisibleRenameFile(false)
      createMessage('Đổi tên file thành công', true, 'success')
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      )
      setIsModalVisibleRenameFile(false)
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      setFileList(newFileList)
      createMessage('Đổi tên file thành công', true, 'success')
    }
  }
  return (
    <Dialog
      open={open}
      onClose={close}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw', // Set your width here
            mx: 0,
            zIndex: 50,
          },
        },
      }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff]"
          sx={{
            fontWeight: 700,
            backgroundColor: '#2C65AC',
          }}>
          <span className="font-bold">Cập nhật công việc</span>
        </DialogTitle>
        <DialogContent>
          {/* <Box>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              <span className="text-red-500">*</span> Tiêu đề:
            </InputLabel>
            <Input
              name="title"
              placeholder={'Nhập tiêu đề...'}
              onChange={formik.handleChange}
              value={formik.values.title}
            />
            {formik.errors.title && formik.touched.title && (
              <p style={{ color: 'red' }}>{formik.errors.title}</p>
            )}
          </Box> */}
          <div style={{ marginTop: 2 }}>
            <TextField
              name="title"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Tiêu đề</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: 'center', height: '56px', width: '100%' }}
              onChange={e => {
                formik.handleChange(e)
              }}
              value={formik.values.title}
              error={formik.errors.title && formik.touched.title ? true : false}
            />
          </div>
          <Box sx={{ paddingBottom: '10px' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Nội dung:
            </InputLabel>
            <RichEditor
              EDITOR_REF={EDITOR_REF}
              setData={setData}
              placeholder={'Nhập nội dung...'}
              editorContent={workDetail?.content}
            />
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="start_date"
                label={
                  <>
                    <span
                      style={{
                        display: 'inline-block',
                        color: '#ff4d4f',
                        fontSize: '14px',
                        fontFamily: 'SimSun,sans-serif',
                        lineHeight: 1,
                      }}>
                      *
                    </span>
                    <span> Ngày bắt đầu</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                // value={advanceFilter.month}
                value={formik.values.start_date}
                onChange={handleChangeStart}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    error={
                      formik.errors.start_date && formik.touched.start_date
                        ? true
                        : false
                    }
                  />
                )}
              />
            </LocalizationProvider>
            {/* {formik.errors.start_date && formik.touched.start_date && (
              <p style={{ color: 'red' }}>{formik.errors.start_date}</p>
            )} */}
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="due_date"
                label={<span>Ngày kết thúc</span>}
                openTo="day"
                // views={["day", "month", "year"]}
                // value={advanceFilterEnd.month}
                value={formik.values.due_date}
                onChange={handleChangeEnd}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    helperText={null}
                    error={false}
                    placeholder="-- Chọn ngày kết thúc --"
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box
            sx={{
              margin: '10px 0',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}>
            <Upload
              valuePropName={'fileList'}
              fileList={fileList}
              multiple={true}
              onChange={handleFileChange}
              beforeUpload={() => false}
              showUploadList={false}>
              <Button variant="contained" className="gap-1">
                <AiOutlineUpload />
                Chọn tài liệu đính kèm
              </Button>
            </Upload>
          </Box>
          <ul
            style={{
              margin: '10px 0 0',
              paddingLeft: '0 !important',
              height: ' auto !important',
              overflow: 'hidden !important',
            }}>
            {fileUploadedList?.map((file, index) => (
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                  transition: 'all ease 0.3s',
                  padding: '3px 0',
                  borderBottom: ' 1px solid #ebebeb',
                  color: '#2C65AC',
                }}
                key={file.file_id}>
                <div className="flex items-center">
                  <AiOutlineFolder className="mr-1 ml-1" />
                  <span style={{ color: '#1890FF' }}>{file.file_name}</span>
                </div>
                <div className="flex items-center">
                  <Button
                    className="text-[#1890FF]"
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      setIsRenameFileUpdate(true)
                      handleOpenPopupRenameFile(file, index)
                    }}>
                    Đổi tên
                  </Button>
                  <AiOutlineDelete
                    className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                    onClick={() => handleRemoveFileUpdate(file.file_id, index)}
                  />
                </div>
              </li>
            ))}
          </ul>

          {fileList.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileList.map((file, index) => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.uid}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span style={{ color: '#1890FF' }}>{file.name}</span>
                  </div>
                  <div className="flex items-center">
                    <Button
                      className="text-[#1890FF]"
                      style={{ textTransform: 'none' }}
                      onClick={() => {
                        handleOpenPopupRenameNewFile(file, index)
                      }}>
                      Đổi tên
                    </Button>
                    <AiOutlineDelete
                      className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                      onClick={() => handleRemoveFileFromUploadList(file.uid)}
                    />
                  </div>
                </li>
              ))}
            </ul>
          )}

          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              <span className="text-red-500">*</span> Người xử lý:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                }>
                <AiOutlineUser />
              </Button>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {handlerList?.map(el => (
                  <SelectList>
                    <Tag
                      name="assignees"
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
          {formik.errors.assignees && formik.touched.assignees && (
            <>
              {/* {formik.errors.assignees.new_items && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  {formik.errors.assignees.new_items}
                </p>
              )} */}
              {formik.errors.assignees.remove_items && (
                <p
                  style={{
                    color: 'red',
                    fontSize: '12px',
                    marginLeft: '10px',
                  }}>
                  {formik.errors.assignees.remove_items}
                </p>
              )}
            </>
          )}
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Người theo dõi:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
                }>
                <AiOutlineUser />
              </Button>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {followerList.map(el => (
                  <SelectList>
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: '#e3e4e9', position: 'sticky', bottom: '0' }}>
          <Button
            sx={{ fontWeight: 600 }}
            onClick={close}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
            Đóng
          </Button>
          <button
            type="submit"
            sx={{ fontWeight: 600 }}
            className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
            {' '}
            Cập nhật
          </button>
        </DialogActions>
      </form>
      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </Dialog>
  )
}
export default inject(
  'workStore',
  'fileStore',
  'selectPeopleStore',
  'loadingAnimationStore'
)(observer(UpdateModal))
